var quiz = {
    title: "Assistance routière de Canadian Tire - Sélecteur de plan",
    questions: [
        {
            text: "Nombre de conducteurs dans votre foyer ?",
            responses: [
                {
                    text: "1 Conducteur",
                    value: 1
                },
                {
                    text: "2-3 Conducteurs",
                    value: 2
                },
                {
                    text: "4+ Conducteurs",
                    value: 4
                }
            ],
        },
        {
            text: "Votre trajet quotidien dépasse t'il 10 km ?",
            responses: [
                {
                    text: "Oui",
                    value: 1

                },
                {
                    text: "Non",
                    value: 2
                }
            ]
        },
        {
            text: "Faites vous un road trip de plus de 50 km au moins une fois par an ?",
            responses: [
                {
                    text: "Oui",
                    value: 1
                },
                {
                    text: "Non",
                    value: 2
                },
            ]
        },
        {
            text: "Possédez-vous plusieurs véhicules ?",
            responses: [
                {
                    text: "Oui",
                    value: 1
                },
                {
                    text: "Non",
                    value: 2
                }
            ],
        },
    ],
};

var answer = {
    "title": "Questionnaire",
    "plans": [
        {
            "values": [
                [{
                    "title":"Programme de membre Or",
                    "text": "<p>Convient aux personnes effectuant des trajets plus longs, quel que soit le véhicule.</p>",
                    "link":"/pages/programme-de-membre-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-member-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de membre Argent",
                    "text": "<p>Convient aux navetteurs urbains, quel que soit le véhicule.</p>",
                    "link":"/pages/programme-de-membre-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-member-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de véhicule Or",
                    "text": "<p>Convient aux personnes qui effectuent des trajets plus longs, quel que soit le conducteur du véhicule enregistré.</p>",
                    "link":"/pages/programme-de-vehicule-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-vehicle-plan-fr.jpg"
                }]
            ],
            "answers": [
                "1111",
                "1121",
                "1211"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de véhicule Or",
                    "text": "<p>Convient aux personnes qui effectuent des trajets plus longs, quel que soit le conducteur du véhicule enregistré.</p>",
                    "link":"/pages/programme-de-vehicule-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-vehicle-plan-fr.jpg"
                
                }],
                [{
                    "title":"Programme de véhicule Argent",
                    "text": "<p>Convient aux personnes dont les trajets sont plus courts, quel que soit le conducteur du véhicule enregistré.</p>",
                    "link":"/pages/programme-de-vehicule-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-vehicle-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de membre Or",
                    "text": "<p>Convient aux personnes effectuant des trajets plus longs, quel que soit le véhicule.</p>",
                    "link":"/pages/programme-de-membre-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-member-plan-fr.jpg"
                }]
            ],
            "answers": [
                "1112",
                "1122",
                "1212"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de membre Argent",
                    "text": "<p>Convient aux navetteurs urbains, quel que soit le véhicule.</p>",
                    "link":"/pages/programme-de-membre-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-member-plan-fr.jpg"
                
                }],
                [{
                    "title":"Programme de véhicule Argent",
                    "text": "<p>Convient aux personnes dont les trajets sont plus courts, quel que soit le conducteur du véhicule enregistré.</p>",
                    "link":"/pages/programme-de-vehicule-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-vehicle-plan-fr.jpg"
                }],
            ],
            "answers": [
                "1221"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de véhicule Argent",
                    "text": "<p>Convient aux personnes dont les trajets sont plus courts, quel que soit le conducteur du véhicule enregistré.</p>",
                    "link":"/pages/programme-de-vehicule-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-vehicle-plan-fr.jpg"
                
                }],
                [{
                    "title":"Programme de membre Argent",
                    "text": "<p>Convient aux navetteurs urbains, quel que soit le véhicule.</p>",
                    "link":"/pages/programme-de-membre-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-member-plan-fr.jpg"
                }]
            ],
            "answers": [
                "1222"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de membre Or + Secondaire",
                    "text": "<p>Convient aux personnes effectuant des trajets plus longs, quel que soit le véhicule.</p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-membre-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-member-plan-fr.jpg"
                    
                
                }],
                [{
                    "title":"Programme de membre Argent + Secondaire",
                    "text": "<p>Convient aux navetteurs urbains, quel que soit le véhicule.</p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-membre-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-member-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de véhicule Or + Secondaire",
                    "text": "<p>Convient aux personnes qui effectuent des trajets plus longs, quel que soit le conducteur du véhicule enregistré.</p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-vehicule-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-vehicle-plan-fr.jpg"
                }]
            ],
            "answers": [
                "2111",
                "2211",
                "2121",
                "3111",
                "3211",
                "3121"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de véhicule Or + Secondaire",
                    "text": "<p>Convient aux personnes qui effectuent des trajets plus longs, quel que soit le conducteur du véhicule enregistré.</p>",
                    "link":"/pages/programme-de-vehicule-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-vehicle-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de véhicule Argent + Secondaire",
                    "text": "<p>Convient aux personnes dont les trajets sont plus courts, quel que soit le conducteur du véhicule enregistré.</p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-vehicule-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-vehicle-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de membre Or + Secondaire",
                    "text": "<p>Convient aux personnes effectuant des trajets plus longs, quel que soit le véhicule.</p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-membre-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-member-plan-fr.jpg"
                }]
            ],
            "answers": [
                "2112",
                "2212",
                "2122",
                "3122",
                "3212",
                "3122"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de membre Argent + Secondaire",
                    "text": "<p>Convient aux navetteurs urbains, quel que soit le véhicule. </p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-membre-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-member-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de famille Argent",
                    "text": "<p>Convient aux familles urbaines avec plusieurs conducteurs dans un même foyer et des trajets plus courts.</p>",
                    "link":"/pages/programme-de-famille-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-family-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de famille Or",
                    "text": "<p>Convient aux familles comptant plusieurs conducteurs dans un même foyer qui parcourent de longues distances.</p>",
                    "link":"/pages/programme-de-famille-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-family-plan-fr.jpg"
                }]
            ],
            "answers": [
                "2221",
                "3221"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de véhicule Argent + Secondaire",
                    "text": "<p>Convient aux personnes dont les trajets sont plus courts, quel que soit le conducteur du véhicule enregistré.</p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-vehicule-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-vehicle-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de famille Argent",
                    "text": "<p>Convient aux familles urbaines avec plusieurs conducteurs dans un même foyer et des trajets plus courts.</p>",
                    "link":"/pages/programme-de-famille-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-family-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de famille Or",
                    "text": "<p>Convient aux familles comptant plusieurs conducteurs dans un même foyer qui parcourent de longues distances.</p>",
                    "link":"/pages/programme-de-famille-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-family-plan-fr.jpg"
                }]
            ],
            "answers": [
                "2222",
                "3222"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de famille Or",
                    "text": "<p>Convient aux familles comptant plusieurs conducteurs dans un même foyer qui parcourent de longues distances.</p>",
                    "link":"/pages/programme-de-famille-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-family-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de membre Or + Secondaire",
                    "text": "<p>Convient aux personnes effectuant des trajets plus longs, quel que soit le véhicule.<p></p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-membre-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-member-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de véhicule Or + Secondaire",
                    "text": "<p>Convient aux personnes qui effectuent des trajets plus longs, quel que soit le conducteur du véhicule enregistré. </p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-vehicule-or",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/gold-vehicle-plan-fr.jpg"
                }]
            ],
            "answers": [
                "4111",
                "4211",
                "4121",
                "4112",
                "4212"
            ]
        },
        {
            "values": [
                [{
                    "title":"Programme de famille Argent",
                    "text": "<p>Convient aux familles urbaines avec plusieurs conducteurs dans un même foyer et des trajets plus courts.</p>",
                    "link":"/pages/programme-de-famille-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-family-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de membre Argent + Secondaire",
                    "text": "<p>Convient aux navetteurs urbains, quel que soit le véhicule.</p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-membre-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-member-plan-fr.jpg"
                }],
                [{
                    "title":"Programme de véhicule Argent + Secondaire",
                    "text": "<p>Convient aux personnes dont les trajets sont plus courts, quel que soit le conducteur du véhicule enregistré. </p><p>Ajoutez une adhésion secondaire pour un membre de votre foyer pour un montant inférieur à celui de l'adhésion principale. Chaque membre supplémentaire bénéficie de la même couverture que le membre principal.</p>",
                    "link":"/pages/programme-de-vehicule-argent",
                    "image":"https://cdn.shopify.com/s/files/1/0091/7674/3987/files/silver-vehicle-plan-fr.jpg"
                }]
            ],
            "answers": [
                "4221",
                "4222"
            ]
        }
    ]
};